export function TargetSingleHouseholdIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="home-user">
      <path id="Vector 9" d="M3.33333 12.6667L16 5.33333L28.6667 12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector" d="M9.33333 28V26.6667C9.33333 22.9848 12.3181 20 16 20C19.6819 20 22.6667 22.9848 22.6667 26.6667V28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path id="Vector_2" d="M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}
